function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Text as PaperText } from 'react-native-paper';
import { Picker } from '@react-native-picker/picker';
import { useHasError } from "../../hooks/useHasError.js";
import { Container } from "../Container/index.js";
export let Select = (_ref) => {
  var _options$map;

  let {
    showErrorOnMount,
    input: {
      onChange,
      value
    },
    meta,
    label,
    options,
    getHelperText,
    ContainerProps,
    LabelProps,
    HelperTextProps
  } = _ref,
      SelectProps = _objectWithoutProperties(_ref, ["showErrorOnMount", "input", "meta", "label", "options", "getHelperText", "ContainerProps", "LabelProps", "HelperTextProps"]);

  let error = useHasError(meta, showErrorOnMount);
  let helperText = getHelperText(error && meta.error);
  return /*#__PURE__*/React.createElement(Container, _extends({}, ContainerProps, {
    HelperTextProps: _objectSpread(_objectSpread({}, HelperTextProps), {}, {
      children: helperText,
      visible: !!helperText,
      type: error ? 'error' : 'info'
    })
  }), /*#__PURE__*/React.createElement(PaperText, LabelProps, label), /*#__PURE__*/React.createElement(Picker, _extends({}, SelectProps, {
    selectedValue: value,
    onValueChange: value => onChange(value)
  }), options && (options === null || options === void 0 ? void 0 : (_options$map = options.map) === null || _options$map === void 0 ? void 0 : _options$map.call(options, ({
    label,
    value
  }) => /*#__PURE__*/React.createElement(Picker.Item, {
    label: label,
    value: value
  })))));
};
Select.displayName = 'Select';
Select.defaultProps = {
  getHelperText: str => str,
  showErrorOnMount: false,
  style: {},
  options: [],
  LabelProps: {},
  ContainerProps: {},
  HelperTextProps: {
    padding: 'normal'
  }
};